import Customer from '@/customer/models/Customer';
import { DossierId } from '@/dossier/models/AbstractDossier';
import User from '@/shared/models/User';
import { present } from '@/shared/utils/typescript';

export interface DossierContactId {__dossierContactId: number}

export default class DossierContact {
  id!: DossierContactId;
  isMain = false;
  isLeasing = false;
  dossierId!: DossierId;
  customer!: Customer;

  asUser(): User {
    return present(User.withIdFullNameAndAvatar(this.customer.id as any, this.customer.fullName, this.customer.avatar));
  }
}
